export const BREADCRUMB_LIST = [
  {
    text: `Sainsbury's Privacy Hub`,
    link: "/",
  },
];

const tagLine = `Sainsbury's Privacy Hub`;
const routes = {
  "/": {
    title: `Home | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `Home`,
      },
    ],
    className: "home",
  },
  "/privacy-policy": {
    title: `Privacy Policy | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `Privacy Policy`,
      },
    ],
    className: "privacy_policy",
  },
  "/cookie-policy": {
    title: `Cookie Policy | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `Cookie Policy`,
      },
    ],
    className: "cookie_policy",
  },
  "/how-to-keep-your-data-safe": {
    title: `How to keep your data safe | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `How to keep your data safe`,
      },
    ],
    className: "data_safety",
  },
  "/your-rights": {
    title: `Your Rights | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `Your Rights`,
      },
    ],
    className: "your_rights",
  },
  "/your-data-at-a-glance": {
    title: `Your data at a glance | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `Your data at a glance`,
      },
    ],
    className: "data_glance",
  },
  "/faq": {
    title: `Frequently Asked Questions | ${tagLine}`,
    breadcrumbs: [
      ...BREADCRUMB_LIST,
      {
        text: `Frequently Asked Questions`,
      },
    ],
    className: "faq",
  },
};

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js